import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostChannelDistributionTemplate } from 'services/templates/channel-distribution-template';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateChannelDistributionSectionTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createChannelDistribution = usePostChannelDistributionTemplate();

  const goBackToContractTemplate = () => navigate('/templates-extended');

  const onCreateChannelDistributionSection = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    const distribution =
      middleware.template.channelDistribution.formToQuery(values);

    if (distribution) {
      await createChannelDistribution.mutateAsync(distribution, {
        onSuccess: id =>
          navigate(`/templates-extended/channel-distribution/${id}/form`),
        onError: error => onErrorShowAllErrorsToast(error),
      });
    }
  };

  return (
    <Form.Contract
      tittle={t('contract-template.channelDistribution.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t(`button.create`)} />
        </Button>
      }
      initialStatus={contractTemplateUtil.distribution.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: contractTemplateUtil.distribution.initialValues(
          TEMPLATE_TYPE.channelDistribution
        ),
      }}
      onSubmit={onCreateChannelDistributionSection}
    />
  );
};

export default CreateChannelDistributionSectionTemplate;
